import React, { useMemo } from "react";
import { QuestionCheckBox as CheckBox } from "./QuestionCheckBox";
import { QuestionText as Text } from "./QuestionText";
import symbol_001 from "../Images/symbol_001.png";
import symbol_002 from "../Images/symbol_002.png";

const images = { symbol_001, symbol_002 };

const components = {
  CheckBox,
  MultipleChoice: CheckBox,
  Text,
};

export function Question({ question, n, formKey }) {
  const Component = components[question.Type] || null;
  if (!Component) {
    return console.error("No question type", question.Type) || null;
  }

  const nAnswers = useMemo(() => {
    if (!question.Answers) return 1;
    return question.Answers.filter((a) => a.Points > 0);
  }, [question]);

  const text = question.Description.replace(/(\[[.+\]])/g, "");
  const match = question.Description.match(/\[\[(.*?)\]\]/)?.[1];
  const cleanedText = text.replace(/\[\[(.*?)\]\]/, "");

  const img = images[match];
  console.log({ match, img });

  return (
    <div className="space-y-2">
      {n !== 0 && (
        <div className="flex flex-row items-center gap-2">
          <h4 className="text-4xl leading-none text-slate-300">{n}</h4>
          <legend className="leading-snug">
            {cleanedText}{" "}
            {img && (
              <div className="py-2">
                <img src={img} />
              </div>
            )}
            {nAnswers > 1 && (
              <strong className="font-bold italic">({nAnswers} answers)</strong>
            )}
          </legend>
        </div>
      )}
      <Component {...question} formKey={formKey} />
    </div>
  );
}
